import { reactive, toRefs } from '@vue/composition-api';
import { debounce } from '@/components/commons/utils.js';

const isBrowser = typeof window !== 'undefined' && !window.isServer;

const state = reactive({
  width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
});

const update = debounce(() => {
  state.width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
}, 1000);

if(isBrowser) {
  window.addEventListener('resize', update);
}

export default function useResize() {
  return {
    ...toRefs(state)
  };
}
